import type {
  IHostingClientFilters,
  ISiteMapMinerFilters,
  ISiteMapRackFilters,
  ISiteMapStructureFilters,
} from '@/types/eos/filters'
import type { IHostingClient, ISiteMapMiner, ISiteMapRack, ISiteMapStructure } from '@/types/eos/SiteMap'
import type { IPage } from '@/types/shared/pagination'
import axios from 'axios'

export async function getSiteMapStructures(filters: ISiteMapStructureFilters): Promise<IPage<ISiteMapStructure>> {
  const res = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/site-map/structures`, {
    params: filters,
  })
  return res.data
}

export async function getSiteMapRacks(filters: ISiteMapRackFilters): Promise<IPage<ISiteMapRack>> {
  const res = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/site-map/racks`, {
    params: filters,
  })
  return res.data
}

export async function getSiteMapMiners(filters: ISiteMapMinerFilters): Promise<IPage<ISiteMapMiner>> {
  const res = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/site-map/miners`, {
    params: filters,
  })
  return res.data
}

export async function getHostingClients(filters: IHostingClientFilters): Promise<IPage<IHostingClient>> {
  const res = await axios.get(`${import.meta.env.VITE_APP_EOSS_API}/hosting-clients`, {
    params: filters,
  })
  return res.data
}

export async function syncSiteMapWithForeman(): Promise<void> {
  const res = await axios.post(`${import.meta.env.VITE_APP_EOSS_API}/site-map/sync`)
  return res.data
}

export async function deactivateSiteMapStructures(ids: string[]): Promise<ISiteMapStructure[]> {
  const res = await axios.post(`${import.meta.env.VITE_APP_EOSS_API}/site-map/structures/deactivate`, { ids })
  return res.data
}

export async function deactivateSiteMapRacks(ids: string[]): Promise<ISiteMapRack[]> {
  const res = await axios.post(`${import.meta.env.VITE_APP_EOSS_API}/site-map/racks/deactivate`, { ids })
  return res.data
}

export async function reactivateSiteMapStructures(ids: string[]): Promise<ISiteMapStructure[]> {
  const res = await axios.post(`${import.meta.env.VITE_APP_EOSS_API}/site-map/structures/reactivate`, { ids })
  return res.data
}

export async function reactivateSiteMapRacks(ids: string[]): Promise<ISiteMapRack[]> {
  const res = await axios.post(`${import.meta.env.VITE_APP_EOSS_API}/site-map/racks/reactivate`, { ids })
  return res.data
}
